(function() {
  'use strict';

  // Lo primero: evitar que cualquier form add-to-cart haga envío nativo (pantalla en blanco). Se ejecuta al cargar el script.
  (function() {
    if (window.__productInfoNativeSubmitBlocked) return;
    window.__productInfoNativeSubmitBlocked = true;
    document.addEventListener('submit', function(e) {
      var t = e.target;
      if (t && t.tagName === 'FORM' && t.getAttribute('data-type') === 'add-to-cart-form') {
        e.preventDefault();
      }
    }, true);
  })();

  // Eliminar texto "template" que aparece debajo de las imágenes
  function removeTemplateText() {
    const mediaContainer = document.querySelector('.product__media-container');
    if (!mediaContainer) return;

    const walker = document.createTreeWalker(
      mediaContainer,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    const nodesToRemove = [];
    while (node = walker.nextNode()) {
      if (node.textContent && node.textContent.includes('template')) {
        nodesToRemove.push(node);
      }
    }

    nodesToRemove.forEach(node => {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    const elementsWithTemplate = mediaContainer.querySelectorAll('*');
    elementsWithTemplate.forEach(el => {
      if (el.textContent && el.textContent.trim().includes('template') && 
          el.textContent.trim().match(/template.*\d+/)) {
        el.style.display = 'none';
        el.textContent = '';
      }
    });
  }

  // Ejecutar inmediatamente y después de que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeTemplateText);
  } else {
    removeTemplateText();
  }

  setTimeout(removeTemplateText, 100);
  setTimeout(removeTemplateText, 500);

  // Galería de imágenes - Inicializar cuando el DOM esté listo
  function initProductGallery() {
    const mediaContainer = document.querySelector('.product__media-container');
    if (!mediaContainer) return;

    const mainImageContainer = mediaContainer.querySelector('.product__media-main-image');
    if (!mainImageContainer) return;

    const thumbnails = mediaContainer.querySelectorAll('.product__media-thumbnail');
    const dots = document.querySelectorAll('.product__media-dot');
    const progressBar = document.querySelector('.product__media-progress-bar');
    let currentIndex = 0;
    const totalImages = thumbnails.length;

    if (totalImages === 0) return;
    
    // Variable para rastrear el índice anterior y determinar la dirección del slide
    // Inicializar con -1 para que la primera imagen no tenga efecto slide
    let previousIndex = -1;

    // Función para cambiar la imagen principal con efecto fade-in
    function changeMainImage(index) {
      if (!mainImageContainer || !thumbnails[index]) return;

      const thumbnail = thumbnails[index];
      
      // Obtener URL de alta resolución directamente del atributo data-high-res
      const highResSrc = thumbnail.getAttribute('data-high-res');
      if (!highResSrc) return;
      
      // Buscar imagen en el thumbnail para obtener alt text
      let thumbnailImg = thumbnail.querySelector('.product__media-thumbnail-image');
      if (!thumbnailImg) {
        thumbnailImg = thumbnail.querySelector('img');
      }
      
      // Guardar URL original del thumbnail como respaldo
      const fallbackSrc = thumbnailImg ? (thumbnailImg.src || thumbnailImg.getAttribute('src') || '') : '';

      // Buscar imagen principal de forma más infalible
      let mainImg = null;
      if (mediaContainer) {
        mainImg = mediaContainer.querySelector('.product__media-main-image img');
      }
      
      // Si no se encuentra, buscar por ID como respaldo
      if (!mainImg) {
        mainImg = document.querySelector('[id^="ProductImage-"]');
      }
      
      // Si aún no se encuentra, buscar por clase
      if (!mainImg) {
        mainImg = mainImageContainer.querySelector('.product__media-image');
      }
      if (!mainImg) {
        mainImg = mainImageContainer.querySelector('img');
      }
      
      if (!mainImg) return;

      // Determinar la dirección del slide basado en el índice anterior
      // Si es la primera imagen (previousIndex === -1), no aplicar efecto
      // Si index > previousIndex, avanzamos (slide-left)
      // Si index < previousIndex, retrocedemos (slide-right)
      const isNext = previousIndex === -1 ? true : index > previousIndex;
      
      // Remover clases de slide anteriores
      mainImg.classList.remove('slide-left-out', 'slide-right-out', 'slide-left-in', 'slide-right-in');
      
      // Si es la primera imagen, no aplicar efecto slide
      if (previousIndex === -1) {
        previousIndex = index;
        // Para la primera imagen, solo actualizar sin animación
        mainImg.setAttribute('src', highResSrc);
        mainImg.removeAttribute('srcset');
        if (thumbnailImg) {
          const altText = thumbnailImg.getAttribute('alt') || thumbnailImg.alt || '';
          if (altText) {
            mainImg.setAttribute('alt', altText);
          }
        }
        return;
      }
      
      // Aplicar efecto slide-out según la dirección
      if (isNext) {
        mainImg.classList.add('slide-left-out');
      } else {
        mainImg.classList.add('slide-right-out');
      }

      setTimeout(function() {
        // CRUCIAL: Limpiar srcset primero para eliminar borrosidad
        mainImg.removeAttribute('srcset');
        
        // Cambiar la imagen
        mainImg.setAttribute('src', highResSrc);
        
        // Actualizar alt text si está disponible
        if (thumbnailImg) {
          const altText = thumbnailImg.getAttribute('alt') || thumbnailImg.alt || '';
          if (altText) {
            mainImg.setAttribute('alt', altText);
          }
        }
        
        // Validación de imagen: Si falla al cargar, volver a la miniatura
        const handleImageError = function() {
          if (fallbackSrc) {
            mainImg.setAttribute('src', fallbackSrc);
            mainImg.removeAttribute('srcset');
          }
          mainImg.removeEventListener('error', handleImageError);
        };
        
        // Agregar handler de error
        mainImg.addEventListener('error', handleImageError, { once: true });
        
        // Remover clase slide-out y aplicar slide-in
        mainImg.classList.remove('slide-left-out', 'slide-right-out');
        
        // Aplicar slide-in en dirección opuesta al slide-out
        if (isNext) {
          mainImg.classList.add('slide-left-in');
        } else {
          mainImg.classList.add('slide-right-in');
        }
        
        setTimeout(function() {
          mainImg.classList.remove('slide-left-in', 'slide-right-in');
        }, 400);
      }, 200);
      
      // Actualizar el índice anterior
      previousIndex = index;

    // Actualizar estado activo de thumbnails
    thumbnails.forEach((thumb, idx) => {
      thumb.classList.remove('product__media-thumbnail--active');
      if (idx === index) {
        thumb.classList.add('product__media-thumbnail--active');
      }
    });

    // Actualizar estado activo de dots
    dots.forEach((dot, idx) => {
      dot.classList.remove('product__media-dot--active');
      if (idx === index) {
        dot.classList.add('product__media-dot--active');
      }
    });

    // Actualizar barra de progreso
    if (progressBar && totalImages > 0) {
      const progress = ((index + 1) / totalImages) * 100;
      progressBar.style.width = progress + '%';
    }

    currentIndex = index;
  }

    // Event listeners para miniaturas - Funciona en mobile y desktop
    // Usar delegación de eventos desde el contenedor
    const thumbnailsContainer = mediaContainer.querySelector('.product__media-thumbnails');
    
    if (thumbnailsContainer) {
      // Delegación de eventos (funciona para elementos dinámicos)
      thumbnailsContainer.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Buscar el thumbnail clickeado (puede ser el botón o la imagen dentro)
        const target = e.target;
        if (!target) return;
        
        let clickedThumbnail = null;
        
        // Si el target es el thumbnail directamente
        if (target.classList && target.classList.contains('product__media-thumbnail')) {
          clickedThumbnail = target;
        } 
        // Si el target está dentro del thumbnail, buscar el padre
        else if (target.closest) {
          clickedThumbnail = target.closest('.product__media-thumbnail');
        } else {
          // Fallback: buscar manualmente hacia arriba
          let element = target;
          while (element && element !== thumbnailsContainer) {
            if (element.classList && element.classList.contains('product__media-thumbnail')) {
              clickedThumbnail = element;
              break;
            }
            element = element.parentElement;
          }
        }
        
        if (!clickedThumbnail) return;
        
        const index = Array.from(thumbnails).indexOf(clickedThumbnail);
        if (index === -1) return;
        
        changeMainImage(index);
      });
    }
    
    // También agregar listeners directos como respaldo (mobile y desktop)
    thumbnails.forEach((thumbnail, index) => {
      // Asegurar que sea clickeable
      if (thumbnail.style) {
        thumbnail.style.cursor = 'pointer';
      }
      thumbnail.setAttribute('role', 'button');
      thumbnail.setAttribute('tabindex', '0');
      
      // Click para mobile
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        changeMainImage(index);
      });
      
      // Hover para desktop (mouseenter)
      thumbnail.addEventListener('mouseenter', function() {
        changeMainImage(index);
      });
      
      // También soportar teclado (accesibilidad)
      thumbnail.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          changeMainImage(index);
        }
      });
    });
    
    // Precarga inteligente: Precargar todas las imágenes de alta resolución
    function preloadHighResImages() {
      thumbnails.forEach(function(thumbnail) {
        const highResUrl = thumbnail.getAttribute('data-high-res');
        if (highResUrl) {
          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = highResUrl;
          document.head.appendChild(link);
        }
      });
    }
    
    // Ejecutar precarga después de un pequeño delay
    setTimeout(preloadHighResImages, 500);

    // Event listeners para dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        changeMainImage(index);
      });
    });

    // Inicializar barra de progreso
    if (progressBar && totalImages > 0) {
      const initialProgress = ((currentIndex + 1) / totalImages) * 100;
      progressBar.style.width = initialProgress + '%';
    }

    // Swipe para mobile
    let touchStartX = 0;
    let touchEndX = 0;

    if (mainImageContainer) {
      mainImageContainer.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      });

      mainImageContainer.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      });

      function handleSwipe() {
        if (touchEndX < touchStartX - 50) {
          if (currentIndex < totalImages - 1) {
            changeMainImage(currentIndex + 1);
          }
        }
        if (touchEndX > touchStartX + 50) {
          if (currentIndex > 0) {
            changeMainImage(currentIndex - 1);
          }
        }
      }
    }
  }

  // Ejecutar cuando la página esté completamente cargada (más seguro para Shopify)
  // Usar window.addEventListener('load') asegura que Shopify terminó de renderizar todo
  if (document.readyState === 'complete') {
    initProductGallery();
  } else {
    window.addEventListener('load', function() {
      initProductGallery();
    });
  }
  
  // También ejecutar después de delays por si el contenido se carga dinámicamente
  setTimeout(initProductGallery, 100);
  setTimeout(initProductGallery, 500);
  setTimeout(initProductGallery, 1000);

  /**
   * Selector de color por variante (migrado de peter): filtrar miniaturas/dots por color.
   * Las imágenes con alt "color|descripción" tienen clase bc_{handle}; al cambiar variante
   * solo se muestran las que coinciden con el color seleccionado.
   */
  function handleizeValue(str) {
    if (!str || typeof str !== 'string') return 'all';
    return str.toLowerCase().trim()
      .replace(/\//g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function getSelectedColorHandle() {
    var colorFieldset = document.querySelector('.variant-option--color, .variant-option--COLOR, fieldset[class*="color"]');
    if (!colorFieldset) return 'all';
    var checked = colorFieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return 'all';
    var val = (checked.getAttribute('data-color-value') || checked.value || '').trim();
    return val ? handleizeValue(val) : 'all';
  }

  function filterThumbnailsByColor(colorHandle) {
    var container = document.querySelector('.product__media-container');
    if (!container) return;
    var thumbnails = container.querySelectorAll('.product__media-thumbnail');
    var dots = container.querySelectorAll('.product__media-dot');
    var mainImg = container.querySelector('.product__media-main-image img');
    var showAll = !colorHandle || colorHandle === 'all';
    var bcClass = 'bc_' + (colorHandle || 'all');

    thumbnails.forEach(function(thumb) {
      var show = showAll || thumb.classList.contains(bcClass);
      thumb.style.display = show ? '' : 'none';
      thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    dots.forEach(function(dot) {
      var show = showAll || dot.classList.contains(bcClass);
      dot.style.display = show ? '' : 'none';
      dot.setAttribute('aria-hidden', show ? 'false' : 'true');
    });

    var firstVisibleThumb = null;
    var firstVisibleIndex = -1;
    for (var i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].style.display !== 'none') {
        firstVisibleThumb = thumbnails[i];
        firstVisibleIndex = i;
        break;
      }
    }
    if (!firstVisibleThumb && !showAll && thumbnails.length > 0) {
      thumbnails.forEach(function(t) { t.style.display = ''; t.setAttribute('aria-hidden', 'false'); });
      dots.forEach(function(d) { d.style.display = ''; d.setAttribute('aria-hidden', 'false'); });
      firstVisibleThumb = thumbnails[0];
      firstVisibleIndex = 0;
    }
    if (firstVisibleThumb && firstVisibleIndex >= 0) {
      thumbnails.forEach(function(t, idx) {
        t.classList.remove('product__media-thumbnail--active');
        if (idx === firstVisibleIndex) t.classList.add('product__media-thumbnail--active');
      });
      dots.forEach(function(d, idx) {
        d.classList.remove('product__media-dot--active');
        if (idx === firstVisibleIndex) d.classList.add('product__media-dot--active');
      });
      if (showAll && mainImg) {
        var highRes = firstVisibleThumb.getAttribute('data-high-res');
        if (highRes) {
          mainImg.classList.remove('slide-left-out', 'slide-right-out', 'slide-left-in', 'slide-right-in');
          mainImg.setAttribute('src', highRes);
          mainImg.removeAttribute('srcset');
        }
      }
    }
    container.setAttribute('data-current-color-handle', colorHandle || 'all');
  }

  function applyColorFilterFromDom() {
    var container = document.querySelector('.product__media-container');
    if (!container) return;
    var current = container.getAttribute('data-current-color-handle');
    var colorHandle = getSelectedColorHandle();
    if (colorHandle !== 'all') {
      filterThumbnailsByColor(colorHandle);
    } else {
      filterThumbnailsByColor(current || 'all');
    }
  }

  function initColorFilter() {
    var container = document.querySelector('.product__media-container');
    if (!container) return;
    var initial = container.getAttribute('data-current-color-handle');
    filterThumbnailsByColor(initial || 'all');
  }

  if (document.readyState === 'complete') {
    setTimeout(initColorFilter, 50);
  } else {
    window.addEventListener('load', function() {
      setTimeout(initColorFilter, 50);
    });
  }
  setTimeout(initColorFilter, 150);
  setTimeout(initColorFilter, 600);

  document.addEventListener('variant:update', function(e) {
    if (!e.detail || !e.detail.resource) return;
    var variant = e.detail.resource;
    var colorHandle = getSelectedColorHandle();
    filterThumbnailsByColor(colorHandle);
    var mainImg = document.querySelector('.product__media-container .product__media-main-image img');
    if (mainImg && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      mainImg.classList.remove('slide-left-out', 'slide-right-out', 'slide-left-in', 'slide-right-in');
      mainImg.setAttribute('src', variant.featured_media.preview_image.src);
      mainImg.removeAttribute('srcset');
    } else {
      updateMainImageFromColorSelection(true);
    }
  });

  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target && target.type === 'radio' && target.name && target.name.startsWith('options')) {
      var fieldset = target.closest('fieldset');
      if (fieldset && (fieldset.classList.contains('variant-option--color') || fieldset.querySelector('.variant-color-label') || fieldset.querySelector('.variant-color-value'))) {
        updateMainImageFromColorSelection(true);
        setTimeout(function() {
          applyColorFilterFromDom();
        }, 50);
      }
    }
  });

  function updateMainImageFromColorSelection(noAnimation) {
    var colorFieldset = document.querySelector('.variant-option--color, fieldset[class*="color"]');
    if (!colorFieldset) return;
    var checked = colorFieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var label = checked.closest('label.variant-option-button--color-thumbnail');
    if (!label) return;
    var mainImageUrl = label.getAttribute('data-main-image-url');
    var mainImg = document.querySelector('.product__media-container .product__media-main-image img');
    if (!mainImageUrl || !mainImg) return;
    if (noAnimation) {
      mainImg.classList.remove('slide-left-out', 'slide-right-out', 'slide-left-in', 'slide-right-in');
    }
    mainImg.setAttribute('src', mainImageUrl);
    mainImg.removeAttribute('srcset');
  }

  // JS Minimalista - Sincronización de variantes
  document.querySelectorAll('.variant-picker__form input, .variant-option-button input[type="radio"]').forEach(input => {
    input.addEventListener('change', (e) => {
      const { value, name } = e.target;
      const labelType = name.includes('Talle') || name.includes('talle') ? '.variant-talle-value' : '.variant-color-value';
      const label = document.querySelector(labelType);
      if (label) label.textContent = value;
    });
  });

  // Función para actualizar el SKU cuando cambia la variante
  function updateSkuOnVariantChange() {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!productForm) {
      return;
    }
    
    const variantIdInput = productForm.querySelector('input[name="id"][ref="variantId"]');
    if (!variantIdInput) {
      return;
    }
    
    const variantId = variantIdInput.value;
    const skuElement = document.getElementById('product-sku');
    const skuContainer = document.getElementById('product-sku-container');
    
    if (!skuElement || !skuContainer) {
      return;
    }
    
    if (!variantId) {
      // Si no hay variantId, ocultar el SKU
      skuElement.textContent = '';
      skuContainer.style.display = 'none';
      return;
    }
    
    // Buscar el SKU en TODOS los inputs del documento
    // Incluir inputs deshabilitados para capturar SKU de productos sin stock
    const allVariantInputs = document.querySelectorAll('input[data-variant-id]');
    let sku = '';
    
    for (let i = 0; i < allVariantInputs.length; i++) {
      const input = allVariantInputs[i];
      if (!input) continue;
      
      const inputVariantId = input.getAttribute('data-variant-id');
      if (inputVariantId && inputVariantId === variantId.toString()) {
        const inputSku = input.getAttribute('data-variant-sku');
        if (inputSku && inputSku.trim() !== '') {
          sku = inputSku.trim();
          break;
        }
      }
    }
    
    // Actualizar el SKU en el DOM
    if (sku && sku.trim() !== '') {
      skuElement.textContent = sku;
      skuContainer.style.display = 'flex';
    } else {
      skuElement.textContent = '';
      skuContainer.style.display = 'none';
    }
  }

  // Inicializar SKU cuando la página carga
  function initializeSku() {
    updateSkuOnVariantChange();
  }

  // Escuchar cambios en los inputs de variantes (talle y color)
  document.addEventListener('change', function(e) {
    const target = e.target;
    if (target && target.nodeName === 'INPUT' && target.type === 'radio' && target.name && target.name.startsWith('options')) {
      // Esperar múltiples veces para asegurar que Shopify haya actualizado el variantId
      setTimeout(function() {
        updateSkuOnVariantChange();
      }, 150);
      
      setTimeout(function() {
        updateSkuOnVariantChange();
      }, 300);
      
      setTimeout(function() {
        updateSkuOnVariantChange();
      }, 500);
    }
  });

  // Escuchar el evento variant:update de Shopify (método principal)
  function setupVariantUpdateListener() {
    const productSection = document.querySelector('[data-testid="product-information"]')?.closest('.shopify-section');
    if (productSection) {
      // Remover listener anterior si existe
      if (productSection._skuVariantUpdateHandler) {
        productSection.removeEventListener('variant:update', productSection._skuVariantUpdateHandler);
      }
      
      // Crear nuevo handler
      productSection._skuVariantUpdateHandler = function(e) {
        if (e.detail && e.detail.resource) {
          const variant = e.detail.resource;
          const skuElement = document.getElementById('product-sku');
          const skuContainer = document.getElementById('product-sku-container');
          
          if (skuElement && skuContainer) {
            // Si el evento trae el SKU, usarlo directamente
            if (variant.sku && variant.sku.trim() !== '') {
              skuElement.textContent = variant.sku.trim();
              skuContainer.style.display = 'flex';
            } else {
              // Si no viene el SKU en el evento, buscar en los inputs
              setTimeout(updateSkuOnVariantChange, 100);
            }
          }
        } else {
          // Si no viene resource, buscar en el formulario
          setTimeout(updateSkuOnVariantChange, 100);
        }
      };
      
      productSection.addEventListener('variant:update', productSection._skuVariantUpdateHandler);
    }
  }

  // Observar cambios en el variantId input directamente
  function observeVariantIdInput() {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!productForm) {
      setTimeout(observeVariantIdInput, 500);
      return;
    }
    
    const variantIdInput = productForm.querySelector('input[name="id"][ref="variantId"]');
    if (!variantIdInput) {
      setTimeout(observeVariantIdInput, 500);
      return;
    }
    
    // Observar cambios en el atributo value
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          setTimeout(updateSkuOnVariantChange, 100);
        }
      });
    });
    
    observer.observe(variantIdInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    
    // También observar cambios en el value usando input event
    variantIdInput.addEventListener('input', function() {
      setTimeout(updateSkuOnVariantChange, 100);
    });
  }

  // Configurar listener cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupVariantUpdateListener();
      initializeSku();
      observeVariantIdInput();
    });
  } else {
    setupVariantUpdateListener();
    initializeSku();
    observeVariantIdInput();
  }
  
  // También inicializar después de un delay para asegurar que todo esté cargado
  setTimeout(function() {
    setupVariantUpdateListener();
    initializeSku();
    observeVariantIdInput();
  }, 500);


  // Procesar texto de acordeones para aplicar negrita antes de los dos puntos
  function processAccordionText() {
    const accordionContents = document.querySelectorAll('.product-accordion-content[data-process-text="true"]');
    
    accordionContents.forEach(content => {
      // Si ya fue procesado, no procesar de nuevo
      if (content.dataset.processed === 'true') return;
      
      // Obtener el HTML original
      let html = content.innerHTML;
      
      // Si el contenido está vacío o solo tiene espacios, no procesar
      if (!html || !html.trim()) {
        content.dataset.processed = 'true';
        return;
      }
      
      // Crear un elemento temporal para trabajar con el HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Procesar cada párrafo o elemento de texto
      const processElement = (element) => {
        // Si es un párrafo o div, procesar su contenido
        if (element.tagName === 'P' || element.tagName === 'DIV' || element.tagName === 'SPAN') {
          const text = element.textContent || element.innerText || '';
          const colonIndex = text.indexOf(':');
          
          // Si tiene dos puntos y hay contenido después
          if (colonIndex > 0 && colonIndex < text.length - 1) {
            const label = text.substring(0, colonIndex).trim();
            const value = text.substring(colonIndex + 1).trim();
            
            if (label && value) {
              // Limpiar el contenido del elemento
              element.innerHTML = '';
              // Añadir label en negrita y valor
              const strong = document.createElement('strong');
              strong.textContent = label + ':';
              element.appendChild(strong);
              element.appendChild(document.createTextNode(' ' + value));
            }
          }
        } else if (element.nodeType === Node.TEXT_NODE) {
          // Es un nodo de texto directo
          const text = element.textContent || '';
          const colonIndex = text.indexOf(':');
          
          if (colonIndex > 0 && colonIndex < text.length - 1) {
            const label = text.substring(0, colonIndex).trim();
            const value = text.substring(colonIndex + 1).trim();
            
            if (label && value) {
              const parent = element.parentNode;
              if (parent && parent.tagName !== 'STRONG') {
                const strong = document.createElement('strong');
                strong.textContent = label + ':';
                const textAfter = document.createTextNode(' ' + value);
                
                parent.insertBefore(strong, element);
                parent.insertBefore(textAfter, element);
                parent.removeChild(element);
              }
            }
          }
        }
      };
      
      // Si el contenido tiene párrafos, procesar cada uno
      const paragraphs = tempDiv.querySelectorAll('p');
      if (paragraphs.length > 0) {
        paragraphs.forEach(p => processElement(p));
      } else {
        // Si no hay párrafos, dividir por saltos de línea y crear párrafos
        const text = tempDiv.textContent || tempDiv.innerText || '';
        const lines = text.split(/\n|<br\s*\/?>/i);
        tempDiv.innerHTML = '';
        
        lines.forEach(line => {
          const trimmedLine = line.trim();
          if (!trimmedLine) return;
          
          const p = document.createElement('p');
          const colonIndex = trimmedLine.indexOf(':');
          
          if (colonIndex > 0 && colonIndex < trimmedLine.length - 1) {
            const label = trimmedLine.substring(0, colonIndex).trim();
            const value = trimmedLine.substring(colonIndex + 1).trim();
            
            if (label && value) {
              const strong = document.createElement('strong');
              strong.textContent = label + ':';
              p.appendChild(strong);
              p.appendChild(document.createTextNode(' ' + value));
            } else {
              p.textContent = trimmedLine;
            }
          } else {
            p.textContent = trimmedLine;
          }
          
          tempDiv.appendChild(p);
        });
      }
      
      // Actualizar el contenido
      content.innerHTML = tempDiv.innerHTML;
      content.dataset.processed = 'true';
    });
  }
  
  // Función auxiliar para escapar HTML
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Ejecutar procesamiento de texto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAccordionText);
  } else {
    processAccordionText();
  }

  // También procesar cuando se abren los acordeones (por si el contenido se carga dinámicamente)
  document.querySelectorAll('.product-accordion-item').forEach(item => {
    item.addEventListener('toggle', processAccordionText);
  });

  // Inicializar visibilidad del SKU
  function initializeSkuVisibility() {
    const skuContainer = document.querySelector('.product-metadata-item--sku');
    const skuElement = document.getElementById('product-sku');
    
    if (skuContainer && skuElement) {
      const skuText = skuElement.textContent?.trim() || '';
      if (skuText) {
        skuContainer.style.display = 'flex';
      } else {
        skuContainer.style.display = 'none';
      }
    }
  }

  // Ejecutar inicialización
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSkuVisibility);
  } else {
    initializeSkuVisibility();
  }

  // Abrir cart drawer después de agregar al carrito - Abrir inmediatamente sin delay
  function setupCartDrawerAutoOpen() {
    document.addEventListener('cart:update', function(event) {
      // Solo abrir si fue una adición exitosa (no un error)
      if (event.detail && event.detail.data && !event.detail.data.didError) {
        // Abrir inmediatamente sin esperar
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer) {
          // Intentar abrir usando el método open si está disponible
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (typeof cartDrawer.showDialog === 'function') {
            // Alternativa: usar showDialog directamente
            cartDrawer.showDialog();
          }
        }
      }
    });
    
    // También escuchar el evento cart:update para abrir el drawer (CartAddEvent usa ese nombre)
    document.addEventListener('cart:add', function(event) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else if (typeof cartDrawer.showDialog === 'function') {
          cartDrawer.showDialog();
        }
      }
    });
  }

  // Feedback del botón "Agregar al Carrito" en PDP (el bloqueo de envío nativo ya se registra al inicio del script)
  function setupAddToCartButtonFeedback() {
    const section = document.querySelector('.product-information');
    if (!section) return;
    const form = section.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    const addButton = form?.querySelector('button[name="add"], .product-action-button--add-to-cart');
    if (!form || !addButton) return;

    // Por si falla todo: que el form no navegue a /cart/add (action = #)
    if (form.getAttribute('action') && form.getAttribute('action').indexOf('cart') !== -1) {
      form.setAttribute('action', '#');
    }

    var restoreTimeout = null;

    function restoreButton() {
      if (restoreTimeout) {
        clearTimeout(restoreTimeout);
        restoreTimeout = null;
      }
      addButton.disabled = false;
      if (addButton.dataset.originalText) {
        addButton.textContent = addButton.dataset.originalText;
      }
    }

    if (!addButton.dataset.originalText) {
      addButton.dataset.originalText = addButton.textContent.trim();
    }

    // Refuerzo: evitar envío nativo también en el form concreto
    form.addEventListener('submit', function(e) {
      e.preventDefault();
    }, { capture: true });

    form.addEventListener('submit', function() {
      addButton.disabled = true;
      addButton.textContent = 'Agregando...';

      // No abrir el drawer aquí: se abre en setupCartDrawerAutoOpen cuando llega cart:update,
      // así el drawer aparece ya con el producto agregado y no vacío.

      // Timeout de seguridad: si no llega cart:update ni cart:error en 12s, rehabilitar el botón
      restoreTimeout = setTimeout(restoreButton, 12000);
    }, { passive: true });

    function onCartDone(e) {
      if (e.type === 'cart:error') {
        restoreButton();
        return;
      }
      if (e.detail && e.detail.data && e.detail.data.source === 'product-form-component' && !e.detail.data.didError) {
        restoreButton();
      }
    }

    document.addEventListener('cart:update', onCartDone);
    document.addEventListener('cart:error', onCartDone);
  }

  // PROTECCIÓN: Prevenir que WhatsApp intercepte clics en botones de compra y selector de cantidad
  function preventWhatsAppInterceptionOnProductButtons() {
    // Ocultar el widget de WhatsApp si existe
    const whatsappWidget = document.querySelector('.wa-optin-widget-container, [class*="wa-optin"], [id*="wa-optin"]');
    if (whatsappWidget) {
      whatsappWidget.style.cssText += 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important;';
    }
    
    // Limpiar cualquier atributo href o onclick de WhatsApp en los botones
    const addToCartButtons = document.querySelectorAll('.product-action-button--add-to-cart, button[name="add"][type="submit"]');
    const buyNowButtons = document.querySelectorAll('.product-action-button--buy-now, [data-buy-now-variant-id]');
    const quantityButtons = document.querySelectorAll('.quantity-selector button, .quantity-minus, .quantity-plus, quantity-selector-component button');
    
    [...addToCartButtons, ...buyNowButtons, ...quantityButtons].forEach(button => {
      // Eliminar cualquier href de WhatsApp
      if (button.hasAttribute('href')) {
        const href = button.getAttribute('href');
        if (href && (href.includes('whatsapp') || href.includes('wa.me'))) {
          button.removeAttribute('href');
        }
      }
      // Eliminar cualquier onclick que pueda redirigir a WhatsApp
      if (button.hasAttribute('onclick')) {
        const onclick = button.getAttribute('onclick');
        if (onclick && (onclick.includes('whatsapp') || onclick.includes('wa.me'))) {
          button.removeAttribute('onclick');
        }
      }
      // Asegurar que el botón no tenga data attributes de WhatsApp
      button.removeAttribute('data-whatsapp');
      button.removeAttribute('data-wa-link');
      // Eliminar cualquier link de WhatsApp dentro del botón
      const whatsappLinks = button.querySelectorAll('a[href*="whatsapp"], a[href*="wa.me"]');
      whatsappLinks.forEach(link => {
        link.removeAttribute('href');
        link.style.display = 'none';
      });
    });
    
    // Limpiar cualquier link de WhatsApp dentro del selector de cantidad
    const quantitySelectors = document.querySelectorAll('.quantity-selector, quantity-selector-component');
    quantitySelectors.forEach(selector => {
      const whatsappLinks = selector.querySelectorAll('a[href*="whatsapp"], a[href*="wa.me"]');
      whatsappLinks.forEach(link => {
        link.removeAttribute('href');
        link.style.display = 'none';
        link.style.visibility = 'hidden';
      });
    });
    
    // Prevenir que scripts externos (ej. WhatsApp) intercepten solo links de WhatsApp. No bloquear propagación
    // en nuestros botones para que "Comprar Ahora" y "Agregar al Carrito" ejecuten sus handlers.
    document.addEventListener('click', (e) => {
      const addToCartButton = e.target.closest('.product-action-button--add-to-cart, button[name="add"], [type="submit"][name="add"]');
      const buyNowButton = e.target.closest('.product-action-button--buy-now, [data-buy-now-variant-id]');
      const quantityButton = e.target.closest('.quantity-selector button, .quantity-minus, .quantity-plus, quantity-selector-component button');
      const quantitySelector = e.target.closest('.quantity-selector, quantity-selector-component');
      const isOurButton = addToCartButton || buyNowButton || quantityButton || quantitySelector;

      if (isOurButton) {
        const whatsappWidget = document.querySelector('.wa-optin-widget-container, [class*="wa-optin"], [id*="wa-optin"]');
        if (whatsappWidget) {
          whatsappWidget.style.cssText += 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important;';
        }
        // Solo prevenir si es un link de WhatsApp; no stopPropagation para que "Comprar Ahora" funcione
        if (e.target.closest('a[href*="whatsapp"]') || e.target.closest('a[href*="wa.me"]')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }
    }, { capture: true, passive: false });
  }

  // Manejar botón "Comprar Ahora" - Usa método nativo de Shopify más confiable
  function setupBuyNowButton() {
    try {
      const buyNowButtons = document.querySelectorAll('.product-action-button--buy-now[data-buy-now-variant-id]');
      if (!buyNowButtons || buyNowButtons.length === 0) {
        return; // No hay botones, salir silenciosamente
      }
      
      buyNowButtons.forEach(button => {
        // Evitar agregar múltiples listeners
        if (button.dataset.buyNowListenerAdded === 'true') {
          return;
        }
        button.dataset.buyNowListenerAdded = 'true';
        
        button.addEventListener('click', function(e) {
          let originalText = null;
          try {
            e.preventDefault();
            e.stopPropagation();
            
            if (this.disabled) return;
            
            // Usar la variante actualmente seleccionada (talle y color) del formulario, no el data del botón
            const productForm = this.closest('product-form-component');
            const variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
            const variantId = variantIdInput ? variantIdInput.value : this.getAttribute('data-buy-now-variant-id');
            if (!variantId) {
              console.warn('No se encontró variant ID para Comprar Ahora');
              return;
            }
            
            // Obtener cantidad del selector de cantidad
            const quantityInput = document.querySelector('.quantity-selector input[type="number"]');
            const quantity = quantityInput ? (quantityInput.value || 1) : 1;
            
            // Deshabilitar el botón mientras se procesa
            this.disabled = true;
            originalText = this.textContent;
            this.textContent = 'Procesando...';
            
            // Usar el método más confiable de Shopify: crear un formulario oculto y enviarlo
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/cart/add';
            form.style.display = 'none';
            
            // Agregar campos del formulario
            const variantInput = document.createElement('input');
            variantInput.type = 'hidden';
            variantInput.name = 'id';
            variantInput.value = variantId;
            form.appendChild(variantInput);
            
            const quantityInputField = document.createElement('input');
            quantityInputField.type = 'hidden';
            quantityInputField.name = 'quantity';
            quantityInputField.value = quantity;
            form.appendChild(quantityInputField);
            
            
            // Agregar return_to para redirigir automáticamente a checkout
            const returnToInput = document.createElement('input');
            returnToInput.type = 'hidden';
            returnToInput.name = 'return_to';
            returnToInput.value = '/checkout';
            form.appendChild(returnToInput);
            
            // Agregar el formulario al body y enviarlo
            document.body.appendChild(form);
            form.submit();
          } catch (error) {
            console.error('Error en botón Comprar Ahora:', error);
            // Rehabilitar botón en caso de error
            if (this) {
              this.disabled = false;
              if (originalText) {
                this.textContent = originalText;
              }
            }
          }
        });
      });
    } catch (error) {
      console.error('Error al configurar botón Comprar Ahora:', error);
    }
  }

  // Inicializar funciones cuando el DOM esté listo
  function initializePurchaseButtons() {
    try {
      // Primero prevenir interceptación de WhatsApp
      preventWhatsAppInterceptionOnProductButtons();
      setupCartDrawerAutoOpen();
      setupAddToCartButtonFeedback();
      setupBuyNowButton();
    } catch (error) {
      console.error('Error al inicializar botones de compra:', error);
    }
  }

  // Esperar a que el DOM esté completamente cargado
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePurchaseButtons);
  } else {
    // Si el DOM ya está cargado, esperar un poco para asegurar que todo esté renderizado
    setTimeout(initializePurchaseButtons, 100);
  }
  
  // También intentar inicializar después de que la página esté completamente cargada
  window.addEventListener('load', function() {
    setTimeout(initializePurchaseButtons, 200);
    // Ejecutar protección contra WhatsApp también después de load
    setTimeout(preventWhatsAppInterceptionOnProductButtons, 300);
  });
  
  // Función para limpiar links de WhatsApp del selector de cantidad (ejecutar periódicamente)
  function cleanWhatsAppLinksFromQuantitySelector() {
    const quantitySelectors = document.querySelectorAll('.quantity-selector, quantity-selector-component, .quantity-selector-wrapper');
    quantitySelectors.forEach(selector => {
      // Buscar y eliminar cualquier link de WhatsApp
      const whatsappLinks = selector.querySelectorAll('a[href*="whatsapp"], a[href*="wa.me"], [href*="whatsapp"], [href*="wa.me"]');
      whatsappLinks.forEach(link => {
        link.removeAttribute('href');
        link.style.display = 'none';
        link.style.visibility = 'hidden';
        link.style.opacity = '0';
        link.style.pointerEvents = 'none';
      });
      
      // Limpiar botones del selector
      const buttons = selector.querySelectorAll('button');
      buttons.forEach(button => {
        if (button.hasAttribute('href')) {
          const href = button.getAttribute('href');
          if (href && (href.includes('whatsapp') || href.includes('wa.me'))) {
            button.removeAttribute('href');
          }
        }
        button.removeAttribute('data-whatsapp');
        button.removeAttribute('data-wa-link');
      });
    });
  }

  // Ejecutar protección contra WhatsApp inmediatamente
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preventWhatsAppInterceptionOnProductButtons);
    document.addEventListener('DOMContentLoaded', cleanWhatsAppLinksFromQuantitySelector);
  } else {
    preventWhatsAppInterceptionOnProductButtons();
    cleanWhatsAppLinksFromQuantitySelector();
  }
  
  // Ejecutar limpieza solo unas pocas veces (no setInterval) para no bloquear el hilo principal y relentizar toda la página/consola
  setTimeout(cleanWhatsAppLinksFromQuantitySelector, 100);
  setTimeout(cleanWhatsAppLinksFromQuantitySelector, 500);
  setTimeout(cleanWhatsAppLinksFromQuantitySelector, 2000);

  // Prevenir submit del formulario cuando no hay stock, pero mantener el botón activo
  function setupAddToCartStockCheck() {
    const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    productForms.forEach(form => {
      // Limpiar cualquier atributo de WhatsApp del formulario
      if (form.hasAttribute('action')) {
        const action = form.getAttribute('action');
        if (action && (action.includes('whatsapp') || action.includes('wa.me'))) {
          form.removeAttribute('action');
        }
      }
      
      form.addEventListener('submit', function(e) {
        // Prevenir interceptación de WhatsApp
        e.stopPropagation();
        
        const submitButton = form.querySelector('button[type="submit"][name="add"]');
        if (!submitButton) return;
        
        // Verificar disponibilidad de la variante actual
        const variantAvailable = submitButton.getAttribute('data-variant-available');
        const isAvailable = variantAvailable === 'true';
        
        if (!isAvailable) {
          // Prevenir el submit pero no deshabilitar el botón
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        
        // Asegurar que el formulario no tenga action de WhatsApp
        if (form.action && (form.action.includes('whatsapp') || form.action.includes('wa.me'))) {
          e.preventDefault();
          form.action = '/cart/add';
          form.submit();
          return false;
        }
      }, { capture: true });
    });
  }

  // Actualizar disponibilidad cuando cambia la variante
  function setupVariantAvailabilityUpdate() {
    // Escuchar el evento de actualización de variante de Shopify
    document.addEventListener('variant:update', function(event) {
      if (!event.detail || !event.detail.resource) return;
      
      const variant = event.detail.resource;
      const isAvailable = variant.available === true;
      
      // Buscar todos los formularios de producto y actualizar sus botones
      const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      productForms.forEach(form => {
        const submitButton = form.querySelector('button[type="submit"][name="add"]');
        if (submitButton) {
          submitButton.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
        }
      });
    });
    
    // También escuchar cambios directos en los inputs de variante como respaldo
    document.addEventListener('change', function(e) {
      const target = e.target;
      if (target && target.matches && target.matches('input[type="radio"][name^="options"]')) {
        // Esperar un momento para que Shopify actualice la variante
        setTimeout(() => {
          const productForm = target.closest('form[data-type="add-to-cart-form"]');
          if (!productForm) return;
          
          const variantIdInput = productForm.querySelector('input[name="id"][ref="variantId"]');
          if (!variantIdInput) return;
          
          const variantId = variantIdInput.value;
          if (!variantId) return;
          
          // Buscar información de disponibilidad en el DOM
          const allVariantInputs = productForm.querySelectorAll('input[type="radio"][data-variant-id]');
          let isAvailable = true;
          
          allVariantInputs.forEach(function(input) {
            if (input.getAttribute('data-variant-id') === variantId) {
              if (input.disabled) {
                isAvailable = false;
              }
            }
          });
          
          // Actualizar el atributo en el botón
          const submitButton = productForm.querySelector('button[type="submit"][name="add"]');
          if (submitButton) {
            submitButton.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
          }
        }, 100);
      }
    });
  }

  // Inicializar verificaciones de stock
  function initializeStockChecks() {
    setupAddToCartStockCheck();
    setupVariantAvailabilityUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStockChecks);
  } else {
    setTimeout(initializeStockChecks, 100);
  }
  
  window.addEventListener('load', function() {
    setTimeout(initializeStockChecks, 200);
  });
})();

